export const settingsAPIUrls = {
  update: '/auth/profile/update',
} as const;
